export function findUser(id, state) {
  const admin = state.admins.list.find(user => user.id === id);
  const editor = state.editors.list.find(user => user.id === id);
  const guest = state.guests.list.find(user => user.id === id);
  return { admin, editor, guest };
}

export function cancelStartIn(state, user, listName) {
  const index = state[listName].list.indexOf(user);
  if (index < 0) {
    return state;
  }
  const newList = [...(state[listName].list)];
  newList[index] = newList[index].merge({ working: true });
  return state.merge({
    [listName]: state[listName].merge({
      list: newList,
    }),
  });
}

export function deleteIn(state, user, listName) {
  const index = state[listName].list.indexOf(user);
  if (index < 0) {
    return state;
  }
  const newList = [...(state[listName].list)];
  newList.splice(index, 1);
  return state.merge({
    [listName]: state[listName].merge({
      list: newList,
    }),
  });
}

export function cancelFailIn(state, user, listName) {
  const index = state[listName].list.indexOf(user);
  if (index < 0) {
    return state;
  }
  const newList = [...(state[listName].list)];
  newList[index] = newList[index].merge({ working: false });
  return state.merge({
    [listName]: state[listName].merge({
      list: newList,
    }),
  });
}

export const BASE_STATE = Object.freeze({
  loading: true,
  list: null,
  error: null,
  page: 1,
  totalPages: 0,
  total: 0,
  limit: 10,
  search: null,
});



// WEBPACK FOOTER //
// ./src/redux/Collaborators/utils.js